export const CONTACT_PHONE = '+420 733 206 890';

export const CONTACT_EMAILS = {
  info: 'info@sizeid.com',
  tech: 'support@sizeid.com',
  marketing: 'press@sizeid.com',
};
